export function getFileExtension(fileName: string) {
  const parts = fileName.split('.');

  return parts.pop();
}